import { useMemo } from 'react'

import type { CustomField } from '@sales-center/common'

import { customValuesToFormModel } from '@user/components/CustomFields'

import type { RequiredFieldsFormModel } from '../typings'

export function useInitialValues(missingFields: CustomField[]) {
  return useMemo<RequiredFieldsFormModel>(
    () => ({ customFields: customValuesToFormModel(missingFields) }),
    [missingFields],
  )
}
